import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '../typography/Typography';

/**
 * `TableRowLabel` provides a container to place a label that sticks to the left
 * when scrolling horizontally.
 *
 * Usage:
 *
 * ```jsx
 * import { TableRowLabel } from '@one-thd/sui-atomic-components';
 * ```
 */
const TableRowLabel = React.forwardRef(({ children }, ref) => {

  return (
    <div className="sui-flex" ref={ref}>
      <div className="sui-sticky sui-left-4 sui-text-left">
        <Typography variant="body-base" height="tight" weight="bold">
          {children}
        </Typography>
      </div>
    </div>
  );
});

TableRowLabel.displayName = 'TableRowLabel';

TableRowLabel.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.string,
};

export { TableRowLabel };